// Local translations
export const T = {
  en_GB: {
    assetClassCorrelations: "Asset Class Correlations",
    description:
      "Define correlation values between asset classes. Values range from -1 (perfect negative correlation) to 1 (perfect positive correlation).",
    loadingCorrelations: "Loading correlations...",
    correlationsSaved: "Saved",
    linkedAssetClasses: "asset classes with linked instruments",
    linkInstrumentsHint: "Link instruments to asset classes to fetch correlations from API",
    fetchFromApi: "Fetch from API",
    copyAll: "Copy All",
    copyEmpty: "Copy Empty",
    save: "Save",
    assetClass: "Asset Class",
    helpText:
      'Top value in each cell is from the API (if available). Bottom input is the stored value. Click "Copy All from API" to copy API values to stored values, then "Save" to persist.',
    failedToFetch: "Failed to fetch correlations",
    failedToSave: "Failed to save correlations",
    valuesOutOfRange: "Correlation values must be between -1 and 1",
    collapsedTitle: "Correlation matrix hidden",
    collapsedReason: (count: number, limit: number) =>
      `This collection has ${count} asset classes — above the ${limit}-item display limit, so the full grid is hidden to keep this page usable.`,
    correlationsStatus: (defined: number, required: number) =>
      `${defined}/${required} correlations are ok`,
    correlationsStatusHint:
      "A pair counts as ok once a value between -1 and 1 is stored for it. Forecasts need every pair: a missing one stops the calculation and is named in the error.",
    downloadCsv: "Download CSV",
    uploadCsv: "Upload CSV",
    csvUploaded: "Saved",
    failedToParseCsv: "Could not import CSV",
    duplicateNamesBlockCsv:
      "Two or more asset classes share the same name — rename them to use CSV import/export.",
  },
  nb_NO: {
    assetClassCorrelations: "Aktivaklassekorrelasjoner",
    description:
      "Definer korrelasjonsverdier mellom aktivaklasser. Verdier varierer fra -1 (perfekt negativ korrelasjon) til 1 (perfekt positiv korrelasjon).",
    loadingCorrelations: "Laster korrelasjoner...",
    correlationsSaved: "Lagret",
    linkedAssetClasses: "aktivaklasser med tilknyttede instrumenter",
    linkInstrumentsHint: "Knytt instrumenter til aktivaklasser for å hente korrelasjoner fra API",
    fetchFromApi: "Hent fra API",
    copyAll: "Kopier alle",
    copyEmpty: "Kopier tomme",
    save: "Lagre",
    assetClass: "Aktivaklasse",
    helpText:
      'Øverste verdi i hver celle er fra API (hvis tilgjengelig). Nederste input er den lagrede verdien. Klikk "Kopier alle" for å kopiere API-verdier til lagrede verdier, deretter "Lagre" for å beholde.',
    failedToFetch: "Kunne ikke hente korrelasjoner",
    failedToSave: "Kunne ikke lagre korrelasjoner",
    valuesOutOfRange: "Korrelasjonsverdier må være mellom -1 og 1",
    collapsedTitle: "Korrelasjonsmatrise skjult",
    collapsedReason: (count: number, limit: number) =>
      `Denne samlingen har ${count} aktivaklasser — over visningsgrensen på ${limit}, så hele rutenettet er skjult for å holde siden brukbar.`,
    correlationsStatus: (defined: number, required: number) =>
      `${defined}/${required} korrelasjoner er ok`,
    correlationsStatusHint:
      "Et par regnes som ok når det er lagret en verdi mellom -1 og 1 for det. Prognosene trenger alle par: et manglende par stopper beregningen og navngis i feilmeldingen.",
    downloadCsv: "Last ned CSV",
    uploadCsv: "Last opp CSV",
    csvUploaded: "Lagret",
    failedToParseCsv: "Kunne ikke importere CSV",
    duplicateNamesBlockCsv:
      "To eller flere aktivaklasser har samme navn — gi dem unike navn for å bruke CSV-import/eksport.",
  },
} as const;
